export function buildAttributesQueryString(attributes) {
    let attributeString = attributes.map(x => `${x.name};${x.value}`).reduce((prev, current) => prev + '|' + current, '');
    return attributeString;
}

export function buildQueryString(searchString, attributes, productPaginationViewModel, articlePaginationViewModel, view) {
    let queryParams = {};
    if (searchString)
        queryParams.searchString = searchString;
    if (productPaginationViewModel.CurrentPageIndex)
        queryParams.p = productPaginationViewModel.CurrentPageIndex;
    if (productPaginationViewModel.CurrentItemsPerPage)
        queryParams.q = productPaginationViewModel.CurrentItemsPerPage;
    if (productPaginationViewModel.CurrentSortBy)
        queryParams.s = productPaginationViewModel.CurrentSortBy;
    const attributesQueryString = buildAttributesQueryString(attributes);
    if (attributesQueryString && attributesQueryString.length > 0)
        queryParams.c = attributesQueryString;
    if (articlePaginationViewModel && articlePaginationViewModel.CurrentPageIndex)
        queryParams.articlePageIndex = articlePaginationViewModel.CurrentPageIndex;
    if (articlePaginationViewModel && articlePaginationViewModel.CurrentItemsPerPage)
        queryParams.articlePageSize = articlePaginationViewModel.CurrentItemsPerPage;
    if (view)
        queryParams.view = view;
    return serialize(queryParams);
}

export function serialize(obj) {
    return '?' + Object.keys(obj).reduce(function (a, k) { a.push(k + '=' + encodeURIComponent(obj[k])); return a; }, []).join('&');
}


// WEBPACK FOOTER //
// ./src/Components/search/Infrastructure/urlBuilder.js